import React, { useState, useEffect } from "react";
import { Dialog, Box, Typography, Button, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
const styles = {
  dialogPaper: {
    borderRadius: "16px",
    padding: "24px",
    width: "100%",
    maxWidth: "400px",
  },
  dialogContainer: { display: "flex", flexDirection: "column", gap: 2 },
  title: { color: "#F57C00", fontWeight: "bold", mb: 1 },
  datePickerContainer: { display: "flex", gap: 2 },
  actionsBox: { display: "flex", gap: 2, mt: 2 },
  cancelButton: { color: "#757575", borderColor: "#E0E0E0" },
  confirmButton: {
    bgcolor: "#F57C00",
    color: "#fff",
    "&:hover": { bgcolor: "#EF6C00" },
    "&:disabled": { bgcolor: "#BDBDBD", color: "#fff" },
  },
};
const LeavePopup = ({ open, onClose, onSubmit, initialDate }) => {
  const { t } = useTranslation();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [reason, setReason] = useState("");
  const [maxDate, setMaxDate] = useState(null);
  useEffect(() => {
    if (open) {
      const date = initialDate ? dayjs(initialDate) : null;
      setFromDate(date);
      setToDate(date);
      setReason("");

      if (date) {
        const daysUntilSunday = (7 - date.day()) % 7;
        const endOfWeekDate = date.add(daysUntilSunday, "day");
        setMaxDate(endOfWeekDate);
      }
    }
  }, [open, initialDate]);

  const handleSubmit = () => {
    if (!fromDate || !toDate || !reason.trim()) return;
    onSubmit({
      from_date: fromDate.format("YYYY-MM-DD"),
      to_date: toDate.format("YYYY-MM-DD"),
      reason,
    });
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: styles.dialogPaper,
      }}
    >
      <Box sx={styles.dialogContainer}>
        <Typography variant="h6" sx={styles.title}>
          {t("layout.attendance.apply_leave")}
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={styles.datePickerContainer}>
            <DatePicker
              label={t("layout.attendance.from")}
              value={fromDate}
              onChange={(newValue) => setFromDate(newValue)}
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              format="DD/MM/YYYY"
              disabled
            />
            <DatePicker
              label={t("layout.attendance.to")}
              value={toDate}
              onChange={(newValue) => setToDate(newValue)}
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              format="DD/MM/YYYY"
              minDate={fromDate}
              maxDate={maxDate}
            />
          </Box>
        </LocalizationProvider>
        <TextField
          label={t("layout.attendance.reason")}
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          fullWidth
          size="small"
          placeholder={t("layout.attendance.enter_leave_reason")}
          required
          error={reason.trim() === "" && reason !== ""}
          helperText={
            reason.trim() === "" && reason !== ""
              ? t("layout.attendance.reason_required")
              : ""
          }
        />
        <Box sx={styles.actionsBox}>
          <Button
            variant="outlined"
            fullWidth
            onClick={onClose}
            sx={styles.cancelButton}
          >
            {t("common.cancel").toUpperCase()}
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={handleSubmit}
            disabled={!fromDate || !toDate || !reason.trim()}
            sx={styles.confirmButton}
          >
            {t("pages.manage_account_page.confirm").toUpperCase()}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default LeavePopup;
